import { ExperienceDto } from "@intelligems/ig-types/dtos/experiences";

export const getUserInterfacesFromExperienceDto = (
  experience: ExperienceDto
) => {
  return experience.variations.flatMap((v) => v.userInterfaces ?? []);
};
